import { render, staticRenderFns } from "./HasMany.vue?vue&type=template&id=52914dd4&"
import script from "./HasMany.vue?vue&type=script&lang=js&"
export * from "./HasMany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports